import type { FaqItem } from "../data/faqs";

// Answers are always visible (not a collapsed accordion) so visitors and
// crawlers both get the full text. The JSON-LD mirrors the visible content.
const Faq = ({
  items,
  title = "Common questions",
}: {
  items: FaqItem[];
  title?: string;
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="mb-16">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <h2 className="text-2xl font-semibold text-white mb-6">{title}</h2>
      <div className="space-y-3">
        {items.map((f) => (
          <div key={f.q} className="p-5 rounded-2xl glass">
            <h3 className="text-white font-medium mb-2">{f.q}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{f.a}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
